
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/catalog",
      function () {
        return require("private-next-pages/account/catalog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/catalog"])
      });
    }
  